/**
 * description 图集稿图片固定位置弹窗
 * created by he.zhikai
 * created on 2017-09-12
 */
"use strict";
angular.module("atlasFixedModule", []).controller("atlasFixedCtrl", ["$scope", "$modalInstance", "$validation", "item", "modalDialog",
    function($scope, $modalInstance, $validation, item, modalDialog) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                positions: [{
                    name: "最前",
                    value: "0"
                }, {
                    name: "最后",
                    value: "1"
                }, {
                    name: "指定位置",
                    value: "2"
                }],
                index: angular.isDefined(item.index) ? item.index : "0",
                counts: angular.isDefined(item.counts) ? item.counts : "0"
            };
            $scope.data.selectedPosition = $scope.data.positions[0].value;
        }

        /**
         * [close description] 取消
         * @return {[type]} [description]
         */
        $scope.close = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确定
         * @return {[type]} [description]
         */
        $scope.confirm = function() {
            $validation.validate($scope.atlasFixedForm).success(function() {
                var newIndex;
                if ($scope.data.selectedPosition == "2") {
                    if (parseInt($scope.data.newIndex) < 1 || parseInt($scope.data.newIndex) > parseInt($scope.data.counts)) {
                        modalDialog.alertType("指定位置必须在1-" + $scope.data.counts + "之间", "", "error", false);
                        return;
                    }
                    newIndex = $scope.data.newIndex;
                } else if ($scope.data.selectedPosition == "0") {
                    newIndex = "1";
                } else if ($scope.data.selectedPosition == "1") {
                    newIndex = $scope.data.counts;
                }
                $modalInstance.close(newIndex);
            }).error(function() {
                modalDialog.saveModel("保存失败", "请检查填写项", "error");
            });
        };
    }
]);